import React from "react";
import styled from "styled-components";

const HeroTitleStyled = styled.div.attrs({
  className: "u-col-center u-items-center u-w100",
})`
  margin-top: 38.2dvh;
  height: auto;
  padding: 48px 0 0;
  background-color: #f0f0f0;
`;

const OsRelease = () => {
  return (
    <HeroTitleStyled>
      <ul className="u-wrapper slideup-center">
        <li className="bodytext-11 u-text-light-gray">
          soremo
          OSは、PC、タブレット、スマートフォンのブラウザで利用できるWEBサービスです。
        </li>
        <li className="bodytext-11 u-text-light-gray">
          現在は、パフォーマンスとUIを一新した、次期バージョンを開発しています。
        </li>
        <li className="bodytext-11 u-text-light-gray">
          本サービスは、ご招待済みのクライアント様および承認済みのスペシャリストの方々のみご利用いただけます。
        </li>
      </ul>
    </HeroTitleStyled>
  );
};

export default OsRelease;
